import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html'
})
export class ProjectsComponent implements OnInit {
  @ViewChild('addDataModal') public addDataModal: ModalDirective;
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild('updateDataModal') public updateDataModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ]
  dataList = [];
  departments = [];
  newForm = {
    name: '',
    punch_slot: '',
    organization: ''
  }

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService:  ConstantService, private apiService: ApiService) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:0,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent
    };

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 150, filter: false,},
      { headerName: 'Organization Name', field: 'org_name', width: 150 },
      { headerName: 'Project Name', field: 'name', width: 250 },
      { headerName: 'Punch Slot', field: 'punch_slot', width: 250 }
    ];

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center']  },
      { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center']  },
      )
    }
   }

  ngOnInit(): void {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listOrg();
    this.listData();
  }
  listData() {
    this.apiService.getData('project').then((resp: []) => {
      _.each(resp, (i) => {
        console.log(this.orgListObj[i.organization])
        i['org_name'] = this.orgListObj[i.organization] ? this.orgListObj[i.organization].name : '';
      });
      this.dataList = resp;
    })
  }

  orgList: any = [];
  orgListObj: any = {};
  listOrg() {
    this.apiService.getData('organization').then((resp: []) => {
      this.orgList = resp;
      _.each(resp, (i) => {
        this.orgListObj[i.srl_no] = i;
      })

      console.log(this.orgList, this.orgListObj);
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'edit') {
      this.newForm = _.clone(this.selectedData);

      this.updateDataModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteDataModal.show();
    }


  }

  savenewForm() {
    // this.newProfileForm.sectors = ((this.selectedItems).map(item => item.item_text)).join(',');

    let duplicateRecord = this.checkForDuplicates(this.newForm);
    if(duplicateRecord) {
      this.alert.type = 'danger';
      this.alert.msg = 'Data already saved';
      setTimeout(() => {
        this.addDataModal.hide();
      this.alert.type = '';
        this.alert.msg = '';
      }, 2000)
    } else {

      this.apiService.addData('project', this.newForm).subscribe((resp) => {
        console.log(resp);
        this.resetForm();
        this.listData();
        this.alert.msg = 'Data has been successfully created.';
        setTimeout(() => {
          this.addDataModal.hide();
          this.alert.msg = '';
        }, 2000)
      })

    }


  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newForm = {
      name: '',
      punch_slot: '',
      organization: ''
    }
  }

  updateProfile() {
    let payload = {
      name: this.newForm.name,
      punch_slot: this.newForm.punch_slot,
      organization: this.newForm.organization
    };
    let that = this;
    this.apiService.updateDetail('project', 'srl_no', this.selectedData.srl_no, payload).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listData();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateDataModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.dataList, (item) => {
      return (item.name).toLowerCase() === (data.name).toLowerCase();
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }

  }


  deleteData() {
    this.apiService.deleteDetail('project', 'srl_no', [this.selectedData.srl_no]).subscribe((resp) => {
      this.listData();
      setTimeout(() => {
        this.deleteDataModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }

}
